import React, { useContext } from "react";
import { UserContext } from "../Context/UserContext";

export default function MyInput(props) {
    const {label, className, type, placeholder, value, onChange, name, onBlur, onFocus, disabled, pattern, inputMode, mendatory} = props;
    const {darkTheme} = useContext(UserContext);
  return (
    <div className="text-sm mb-2">
      <label>{label} <span className="text-red-500 font-bold">{mendatory}</span></label>
      <input {...props} pattern={pattern} inputMode={inputMode} onBlur={onBlur} onFocus={onFocus} disabled={disabled} name={name} type={type} value={value} onChange={onChange} placeholder={placeholder} className={`border uppercase rounded-lg py-[8px] px-3 outline-none ${className} ${darkTheme? "bg-gray-700 placeholder:text-slate-400 border-gray-500" : "border-gray-500 bg-[#ffff]"}`} />
    </div>
  );
}
